module.exports = __webpack_public_path__ + "media/site/images/startups/tatralife-eca34c230edaf9325979540dedf4a159.png";